/**
 * 校验用户名：字母、数字、下划线
 * @param {string} username
 * @returns {Boolean}
 */
export function validUsername(username) {
    const reg = /^[0-9a-zA-Z_.\-()<>]{1,}$/
    return reg.test(username)
}

/**
 * 校验昵称：字母、数字、下划线、中文、空格
 * @param {string} nickname
 * @returns {Boolean}
 */
export function validNickname(nickname) {
    const reg = /^[a-zA-Z0-9_.\-()<> \u4e00-\u9fa5]+$/
    return reg.test(nickname)
}

/**
 * 数字和字母
 * @param {string} id
 * @returns {Boolean}
 */
export function validID(id) {
    const reg = /^[a-zA-Z0-9]+$/
    return reg.test(id)
}

/**
 * 校验手机号码
 * @param {string} phone
 * @returns {Boolean}
 */
export function validPhone(phone) {
    return /^1(3|4|5|6|7|8|9)\d{9}$/.test(phone)
}

/**
 * 校验数字，最多6位小数
 * @param {string} number
 * @returns {Boolean}
 */
export function validNumber(number) {
    const reg = /(^[1-9]([0-9]+)?(\.[0-9]{0,6})?$)|(^(0){1}$)|(^[0-9]\.[0-9]{0,6}?$)/
    return reg.test(number)
}

/**
 * 校验数字，整数部分不超过 n 位
 * @param {string} number
 * @returns {Boolean}
 */
export function validNumber2(number, n) {
    if (validNumber(number)) {
        return parseInt(number).toString().length <= n
    }
    return false
}

/**
 * 校验比例，最多2位小数
 * @param {string} rate
 * @returns {Boolean}
 */
export function validRate(rate) {
    const reg = /(^[1-9]([0-9]+)?(\.[0-9]{0,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]{0,2}?$)/
    if (reg.test(rate)) {
        return rate - 1 <= 0
    }
    return false
}
/**
 * @param {string} url
 * @returns {Boolean}
 */
export function validURL(url) {
    const reg = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/
    return reg.test(url)
}

/**
 * 域名校验
 * @param {string} domain
 * @returns {Boolean}
 */
export function validDomain(domain) {
    const reg = /^(?=^.{3,255}$)[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+$/
    return reg.test(domain)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validLowerCase(str) {
    const reg = /^[a-z]+$/
    return reg.test(str)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validUpperCase(str) {
    const reg = /^[A-Z]+$/
    return reg.test(str)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validAlphabets(str) {
    const reg = /^[A-Za-z]+$/
    return reg.test(str)
}

/**
 * @param {string} email
 * @returns {Boolean}
 */
export function validEmail(email) {
    const reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return reg.test(email)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function isString(str) {
    if (typeof str === 'string' || str instanceof String) {
        return true
    }
    return false
}

/**
 * @param {Array} arg
 * @returns {Boolean}
 */
export function isArray(arg) {
    if (typeof Array.isArray === 'undefined') {
        return Object.prototype.toString.call(arg) === '[object Array]'
    }
    return Array.isArray(arg)
}

export function second2Time(second) {
    let hours = Math.floor((second % (60 * 60 * 24)) / (60 * 60));
    let minutes = Math.floor((second % (60 * 60)) / (60));
    let seconds = Math.round((second % (60)));
    return hours + "时" + minutes + "分" + seconds + "秒";
}

/**
 * 校验基本的银行卡格式
 * @param {string} bank
 * @returns {Boolean}
 */
export function validBank(bank) {
    const reg = /^([1-9]{1})(\d{14}|\d{18})$/
    return reg.test(bank)
}


// WEBPACK FOOTER //
// ./src/common/validUtil.js